import { signApiGatewayRequest } from '../../components/utils/amplifyAuthHelpers';

/**
 * Local backend base URL. Prefer REACT_APP_LOCAL_API_URL when using a non-default port
 * (e.g. http://localhost:3011 while 3001 is already in use).
 */
const localApiBase = () =>
  (process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:3001').replace(/\/$/, '');

/**
 * Extract path + query from an absolute or path-only endpoint.
 * @param {string} endpoint
 * @returns {string}
 */
const endpointPath = (endpoint) => {
  try {
    const u = new URL(endpoint);
    return `${u.pathname}${u.search}`;
  } catch (_) {
    const parts = String(endpoint).split(/localhost:\d+/);
    return parts[1] || endpoint;
  }
};

const createSignedRequest = async (method, endpoint, data = '', headers = {}) => {
  let resolvedEndpoint = endpoint;

  // For Local Testing — rewrite host/port without assuming :3001
  if (process.env.REACT_APP_LOCAL_BACK_TEST) {
    const path = endpointPath(endpoint);
    if (['/payment'].some((x) => endpoint.includes(x))) {
      resolvedEndpoint = `http://localhost:3002${path}`;
    } else if (['/registration', '/authentication'].some((x) => endpoint.includes(x))) {
      resolvedEndpoint = `http://localhost:3003${path}`;
    } else {
      resolvedEndpoint = `${localApiBase()}${path}`;
    }
  }

  return signApiGatewayRequest(method, resolvedEndpoint, data, headers);
};

export default createSignedRequest;
